// Initialize the global p3 object closure
if(!P3Portal.Config) P3Portal.Config = {}
P3Portal.boot = [];
P3Portal.Events = _.extend({}, Backbone.Events);

P3Portal.getRecentCustomers = function(){
  var recent = false,
    getStorage = window.localStorage.getItem('p3.recentCustomers');
  if(getStorage){
    var parse = JSON.parse(getStorage);
    if(parse){
      recent = parse;
    }
  }
  P3Portal.recentCustomers = recent;
  $( window ).on("unload", function() {
    window.localStorage.setItem('p3.recentCustomers', JSON.stringify(P3Portal.recentCustomers));
  });
}

P3Portal.init = function(){
  var execute;
  // These functions will get booted
  P3Portal.getRecentCustomers();
  for(var i = 0; i < P3Portal.boot.length; i++){
    execute = P3Portal.boot[i];
    if(typeof(execute) == 'function') execute();
    if(typeof(execute) == 'object') execute.init();
  }
};
